<div class="scanner-card-row" [class.print-mode]="printMode" (click)="onCardClick()">
  @if (printMode) {
    <div class="scanner-card-checkbox" [class.checked]="isSelected">
      @if (isSelected) {
        <i class="fa fa-check"></i>
      }
    </div>
  }
  <div class="scanner-card" [class.unexpected]="data.isUnexpected" [class.selected]="printMode && isSelected">
    <div class="scanner-card-header">
      <span class="scanner-card-stock-no">{{ data.stockNo }}</span>
      <div class="scanner-card-badges">
        @if (data.isUnexpected) {
          <span class="scanner-card-unexpected-badge" i18n>NOT EXPECTED</span>
        }
        <span class="scanner-card-balance-badge">{{ formattedBalance }}</span>
      </div>
    </div>

    <div class="scanner-card-description">{{ data.productDescription }}</div>

    <div class="scanner-card-details">
      <div class="scanner-card-detail">
        <div class="scanner-card-detail-label" i18n>PRODUCT KEY</div>
        <div class="scanner-card-detail-value">{{ data.productKey }}</div>
      </div>
      <div class="scanner-card-detail">
        <div class="scanner-card-detail-label" i18n>BATCH</div>
        <div class="scanner-card-detail-value">{{ data.batchNo }}</div>
      </div>
      <div class="scanner-card-detail">
        <div class="scanner-card-detail-label" i18n>LOCATION</div>
        <div class="scanner-card-detail-value">{{ data.location }}</div>
      </div>
    </div>
  </div>
</div>
